"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/*
 * © 2024 Renishaw plc. All rights reserved.
 * This source file is the confidential property and copyright of Renishaw plc
 * Reproduction or transmission in whole or in part, in any form or
 * by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 */
const react_1 = __importDefault(require("react"));
const styled_components_1 = require("../../styled-components");
const Base_1 = require("../Base");
const Invisible = ({ size = 16, fill, name, }) => {
    const theme = (0, styled_components_1.useTheme)();
    return (react_1.default.createElement(Base_1.Base, { size: size, fill: fill !== null && fill !== void 0 ? fill : theme.icon, smooth: true },
        react_1.default.createElement("title", null, name),
        react_1.default.createElement("path", { d: "M13.2 5.5c.7.7 1.3 1.6 1.8 2.5-1.6 3-4.1 5-7 5l-.8-.1L8.7 11a3.1 3.1 0 0 0 2.5-3v-.1l2-2.4z\n      M8 3l1.8.3-1.3 1.6-.5-.1A3.2 3.2 0 0 0 4.8 8l.3 1.2-1.6 2C2.5 10.3 1.7 9.3 1 8c1.6-3 4.1-5 7-5z\n      m4.4-1.5L14 2.8 4.6 14.6 3 13.3l9.4-11.8z" })));
};
exports.default = Invisible;
//# sourceMappingURL=index.js.map